<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <PageHeader :items="items" :title="title" />
        <b-card>
          <form action="">
            <div class="form-row">
              <div class="col-md-6 col-sm-6 col-lg-4">
                <label class="col-form-label col-form-label-sm" for="ep_id"
                  >EP ID</label
                >
                <input
                  id="ep_id"
                  v-model="search_data.ep_id"
                  class="form-control form-control-sm"
                  name="ep_id"
                  placeholder="EP ID"
                  type="text"
                />
              </div>
              <div class="col-md-6 col-sm-6 col-lg-4">
                <label class="col-form-label col-form-label-sm" for="name"
                  >Paid to:</label
                >
                <input
                  id="name"
                  v-model="search_data.name"
                  class="form-control form-control-sm"
                  name="name"
                  placeholder="Paid to"
                  type="text"
                />
              </div>
              <div class="col-md-6 col-sm-6 col-lg-4">
                <label class="col-form-label col-form-label-sm" for="nid"
                  >National ID</label
                >
                <input
                  id="nid"
                  v-model="search_data.nid"
                  class="form-control form-control-sm"
                  name="nid"
                  placeholder="National ID"
                  type="text"
                />
              </div>
            </div>
            <div class="form-row mt-1">
              <div class="col-md-6 col-sm-6 col-lg-4">
                <label
                  class="col-form-label col-form-label-sm"
                  for="district_id"
                  >District</label
                >
                <select
                  id="district_id"
                  v-model="search_data.district_id"
                  class="form-control form-control-sm"
                  name="district_id"
                >
                  <option :value="''" selected>Select a District</option>
                  <option
                    v-for="(district, index) in districts"
                    :key="index"
                    :value="district.id"
                    >{{ district.id }} :
                    {{ district.district_desc }}
                  </option>
                </select>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-4">
                <label class="col-form-label col-form-label-sm" for="mouza_id"
                  >Mouza</label
                >
                <select
                  id="mouza_id"
                  v-model="search_data.mouza_id"
                  class="form-control form-control-sm"
                  name="mouza_id"
                >
                  <option :value="''" selected>Select a Mouza</option>
                  <option
                    v-for="(mouza, index) in mouzas"
                    :key="index"
                    :value="mouza.id"
                    >{{ mouza.id }} :
                    {{ mouza.mouza_desc }}
                  </option>
                </select>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-4">
                <label class="col-form-label col-form-label-sm" for="ep_type"
                  >Ep Type</label
                >
                <select
                  id="ep_type"
                  v-model="search_data.ep_type"
                  class="form-control form-control-sm"
                  name="ep_type"
                >
                  <option :value="''" selected>Select a EP Type</option>
                  <option value="1">Titled</option>
                  <option value="2">Non-titled</option>
                </select>
              </div>
            </div>
            <button class="btn btn-success btn-sm mt-2" @click.prevent="search"
              >Search</button
            >
          </form>
        </b-card>

        <b-card>
          <div v-if="seses.length > 0" class="mb-1">
            <div class="form-row">
              <div class="col-md-6">
                <span class="badge badge-success"
                  >Total Search Data Found: {{ seses.length }}</span
                >
              </div>
              <div class="col-md-6"></div>
            </div>
          </div>

          <div class="table-responsive" style="overflow-x: auto">
            <table id="titledExcel" class="table table-striped">
              <thead>
                <tr>
                  <th></th>
                  <th>EP ID</th>
                  <th>Name</th>
                  <th>Voucher No.</th>
                  <th>Cheque No.</th>
                  <th>Cheque Date</th>
                  <th>Bank Name</th>
                  <th>Account No.</th>
                  <th>Voucher Amount</th>
                  <th>Paid EP As</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(ses, index) in seses" :key="index">
                  <td>
                    <i
                      @click.prevent="getChequePrint(ses, ses.id)"
                      title="Cheque Print"
                      class="fa fa-print chequePrint"
                      aria-hidden="true"
                    ></i>
                  </td>
                  <td>{{ epIdWithPaymentStatus(ses.ep_id, ses.is_paid) }}</td>
                  <td>{{ ses.name }}</td>
                  <td>{{ ses.voucher_no }}</td>
                  <td>{{ ses.cheque_no }}</td>
                  <td>{{ ses.cheque_date }}</td>
                  <td>{{ ses.ses_bank ? ses.ses_bank.bank.bank_desc : '' }}</td>
                  <td>{{ ses.ses_bank ? ses.ses_bank.account_no : '' }}</td>
                  <td> {{ tofloatFix(ses.total_amount) }}</td>
                  <td>{{
                    ses.ep_types
                      ? ses.ep_types[0]
                        ? ses.ep_types[0].ep_type_desc
                        : ''
                      : ''
                  }}</td>
                </tr>
              </tbody>
            </table>
            <div v-if="loader" class="loader">Loading...</div>
            <h5
              v-if="seses.length === 0 || !flag"
              class="text-center text-secondary"
            >
              No Data Found
            </h5>
          </div>
        </b-card>
        <b-card v-if="Object.keys(ses).length !== 0" style="display: none">
          <div id="print">
            <div class="print-conteiner sheet">
              <div class="pHead">
                <div class="date-container">
                  <span>
                    <span>{{ current_date[0] }}</span>
                  </span>
                  <span>
                    <span>{{ current_date[1] }}</span>
                  </span>
                  <span>
                    <span>{{ current_date[3] }}</span>
                  </span>
                  <span>
                    <span>{{ current_date[4] }}</span>
                  </span>
                  <span>
                    <span>{{ current_date[6] }}</span>
                  </span>
                  <span>
                    <span>{{ current_date[7] }}</span>
                  </span>
                  <span>
                    <span>{{ current_date[8] }}</span>
                  </span>
                  <span>
                    <span>{{ current_date[9] }}</span>
                  </span>
                </div>
              </div>
              <div class="pable">
                <p>A/C Payee</p>
              </div>
              <p class="payto">
                <strong class="EPName"
                  >{{ ses.name }} ( EP ID: {{ ses.ep_id }} & Acc. No.:
                  {{ ses.ses_bank.account_no }} )</strong
                >
              </p>
              <p class="sumTaka">
                <strong class="textNumber">{{
                  ses.inWordTaka | capitalize
                }}</strong>
              </p>
              <span class="amount">
                <span>{{ tofloatFix(ses.total_amount) }}</span>
              </span>
              <div class="backSlip">
                <div class="scontainer">
                  <div class="BSB">
                    <p>{{ ses.name }}</p>
                    <p>{{ tofloatFix(ses.total_amount) }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-card>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from '@src/app.config.json'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import http from '@state/http'
import XLSX from 'xlsx'
import { ToWords } from 'to-words'
import moment from 'moment'
import { epIdWithPaymentStatus } from '@/src/utils/format-epid'

export default {
  page: {
    title: 'List of Print Voucher',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: 'List of Print Voucher',
      items: [
        {
          text: 'Dashboard',
          href: '/',
        },
        {
          text: 'List of Print Voucher',
          active: true,
        },
      ],
      search_data: {
        ep_id: '',
        district_id: '',
        name: '',
        nid: '',
        mouza_id: '',
        ep_type: '',
      },
      voucherSelected: '',
      mouzas: [],
      districts: [],
      seses: {},
      ses: {},
      flag: false,
      loader: false,
      current_date: '',
      chequeView: false,
    }
  },

  mounted() {
    this.search_data.district_id = this.$route.params.district_id
    this.search_data.ep_type = this.$route.params.ep_type
    this.getCodes()
    this.checkCurrentDate()
  },
  methods: {
    epIdWithPaymentStatus: epIdWithPaymentStatus,
    checkCurrentDate() {
      this.current_date = moment().format('DD-MM-YYYY')
    },
    getCodes() {
      http.get('api/payment/codes').then((response) => {
        if (!response.error) {
          let data = response.data
          this.districts = data.districts
          this.mouzas = data.mouzas
        }
      })
    },
    tofloatFix(amountToFloat) {
      return parseFloat(amountToFloat).toFixed(2)
    },
    search() {
      this.flag = true
      this.loader = true
      http
        .post('api/payment/cheque/print', this.search_data)
        .then((response) => {
          if (!response.error) {
            this.flag = true
            this.loader = false
            this.seses = response.data.seses
          }
        })
    },
    getResults(page = 1) {
      this.flag = true
      this.loader = true
      http
        .post('api/payment/cheque/print?page=' + page, this.search_data)
        .then((response) => {
          this.flag = true
          this.loader = false
          this.seses = response.data.seses
        })
    },
    onexport(evt) {
      var tbl = document.getElementById('titledExcel')
      var wb = XLSX.utils.table_to_book(tbl)
      XLSX.writeFile(wb, 'print-voucher.xlsx')
    },
    getChequePrint(ses) {
      this.ses = ses
      setTimeout(() => {
        this.chequePrint()
      })
    },
    chequePrint() {
      // Get HTML to print from element
      const prtHtml = document.getElementById('print').innerHTML

      // Get all stylesheets HTML
      let stylesHtml = ''
      for (const node of [
        ...document.querySelectorAll('link[rel="stylesheet"], style'),
      ]) {
        stylesHtml += node.outerHTML
      }

      // Open the print window
      const WinPrint = window.open('', '', 'width=1000,height=600')

      WinPrint.document.write(`<!DOCTYPE html>
                        <html>
                          <head>
                            ${stylesHtml}
                            <style>.sheet {margin: 0;overflow: hidden;position: relative;box-sizing: border-box;page-break-after: always;}body.cheque .sheet { width: 22.86cm; height: 7.62cm; margin:0px;} @media print {body.cheque { width: 22.86cm;}.date-container>span>span,.amount>span{border-width: 0px;}}</style>
                          </head>
                          <body style="background: #ffffff">
                            ${prtHtml}
                          </body>
                        </html>`)

      WinPrint.document.close()
      WinPrint.focus()
      WinPrint.print()
      // WinPrint.close();
    },
  },
  filters: {
    toWords: function(value) {
      const toWords = new ToWords({
        localeCode: 'en-IN',
        converterOptions: {
          currency: true,
          ignoreDecimal: false,
          ignoreZeroCurrency: false,
        },
      })
      if (!value) return ''
      return toWords.convert(value, { currency: true })
    },
    capitalize: function(value) {
      if (!value) return ''
      return value.toUpperCase()
    },
  },
  computed: {
    userPermission() {
      return this.$store.state.user
    },
  },
  created() {
    this.$store.dispatch('getUserPermission')
  },
}
</script>
<style>
@media print {
  @page {
    size: landscape;
  }
}
.chequePrint {
  cursor: pointer;
  color: red;
}
.sumTaka.customModel {
  background: rgba(0, 0, 0, 0.2);
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  z-index: 9999;
  overflow-x: auto;
}

.CM-body {
  background: white;
  min-height: 10.16cm;
  height: auto;
  width: 9in;
  float: none;
  margin: auto;
  margin-top: auto;
  margin-top: 10%;
  padding-top: 0;
}

.print {
  position: absolute;
  bottom: 10px;
}

.print-conteiner {
  float: none;
  margin: 0;
  width: 25.5cm;
  min-height: 8.89cm;
  height: auto;
  position: relative;
  background: rgb(255, 255, 255);
  overflow: hidden;
  box-sizing: border-box;
  page-break-after: always;
  padding: 55px 0 0 20px;
}

.date-container {
  display: inline-block;
  float: right;
  margin-top: -4px;
  padding-top: 20px;
  margin-left: -8px;
}

.date-container > span {
  display: block;
  width: 26px;
  float: left;
  text-align: right;
  padding: 0px 1px;
}

.date-container > span > span {
  outline: 0px;
  width: 100%;
  text-align: center;
  border: 0.1px solid;
  padding: 3.5px 7.5px;
  font-family: sans-serif;
  font-size: 105%;
  line-height: 1.15;
  margin: 0;
}

.print-conteiner > p.payto {
  padding-left: 90px;
  padding-top: 20px;
}

.print-conteiner > p.sumTaka:first-letter {
  padding-left: 96px;
}

.print-conteiner > p {
  font-size: 12px;
  margin: 0px;
  text-align: justify;
}

.payto {
  position: absolute;
  top: 115px;
  left: 172px;
}

.sumTaka {
  position: absolute;
  top: 135px;
  left: 230px;
  width: 11cm;
  line-height: 3;
  padding-top: 25px;
}

.amount {
  position: absolute;
  right: 0.01cm;
  top: 185px;
  width: 215px;
}

.amount > span {
  outline: 0px;
  width: 5.7cm;
  height: 1.3cm;
  font-size: 20px;
  border: 0.1px solid;
  text-align: left;
  padding-left: 15px;
  padding-top: 20px;
  padding-bottom: 9px;
  padding-right: 100px;
}

.backSlip {
  position: absolute;
  bottom: 1.8cm;
  left: 2.7cm;
  top: 102px;
}

.backSlip .BSB {
  transform: rotate(-90deg);
  position: absolute;
  top: -10px;
  bottom: -10px;
  width: 3.95cm;
  line-height: 1.5;
}

.scontainer {
  position: relative;
  height: 100%;
  margin-left: 30px;
  margin-top: 25px;
}

.backSlip .BSB > p {
  font-size: 10px;
  margin: 0px;
  padding-left: 50px !important;
  width: 200px;
}

/*
@media print{

   .no-print,.searchData, .navbar-wrapper,.modal,.container,#footer,.footer,.print,.closebtn{
          display: none;
    }
    .date-container>span>input,.amount>input{
        border-width: 0px;
    }
.print-conteiner{float: left;margin-top: 0px}

  body{
    padding: 0px;
    margin: 0px
  }

 .print-conteiner {

  margin: 0;
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
  page-break-after: always;
  page-break-inside : auto
 }

.footer,.print-conteiner {
    margin-top: 0px ! important;
    border: 0px solid ! important;


}

.CM-body {
    margin-top: 0%;
    padding-top: 0px;
    width: 22.86cm;
    height: 7.62cm;
    margin: 0px;
    float: left;
}

  }
*/

.closebtn {
  position: absolute;
  right: 20px;
  bottom: 10px;
}

.pable > p {
  border-top: 2px solid;
  border-bottom: 2px solid;
  transform: rotate(-38deg);
  margin-top: -10px;
  width: 290px;
  margin-left: -85px;
  padding-left: 75px;
  font-size: 12px;
}

.pable {
  margin-left: 148px;
  font-weight: bold;
  color: blue;
  width: 230px;
  height: 193px;
  overflow: hidden;
}

.sheet {
  margin: 0;
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
  page-break-after: always;
  color: black;
}

body.cheque .sheet {
  width: 22.86cm;
  height: 7.62cm;
  margin: 0px;
}

@media print {
  .date-container > span > span,
  .amount > span {
    border-width: 0px;
  }
}

@page {
  margin: 0;
}

.sheet {
  margin: 0;
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
  page-break-after: always;
}
</style>
